import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-pagetitle",
  templateUrl: "./pagetitle.component.html",
  styleUrls: ["./pagetitle.component.scss"],
})

/**
 * Page Title Component
 */
export class PagetitleComponent implements OnInit {
  @Input()
  breadcrumbItems!: Array<{
    active?: boolean;
    label?: string;
  }>;

  @Input() title: string | undefined;
  
  @Input() icon: string | undefined;
  
  @Input() subtitle: string | undefined;

  constructor() {}

  ngOnInit(): void {}
}
